<kendo-dropdownlist
  [value]="value"
  [valuePrimitive]="true"
  [data]="optionSet.values"
  [textField]="'label'"
  [valueField]="'name'"
  (valueChange)="onValueChange($event)"
  [popupSettings]="{ popupClass: 'popup-custom-style' }">
</kendo-dropdownlist>
